import React from "react";
import { formatDateOnly } from "@/lib/date";
import { fmtMinutes } from "@/components/shownotes/meta";

export const SEGMENTS = [
  { key: "act1", label: "Act I", dot: "bg-sky-500" },
  { key: "intermission", label: "Intermission", dot: "bg-amber-400" },
  { key: "act2", label: "Act 2", dot: "bg-rose-500" },
];

// One performance: date + stacked Act I / Intermission / Act 2 bar scaled to the longest show.
export default function RunTimeRow({ p, max }) {
  return (
    <div className="grid grid-cols-[7.5rem_1fr_6.5rem] items-center gap-3 text-sm" data-testid={`runtimes-row-${p.id}`}>
      <div>
        <p className="font-medium text-slate-800">{formatDateOnly(p.date)}</p>
        <p className="text-[11px] text-slate-400">Report #{p.report_number}</p>
      </div>
      <div className="flex h-6 overflow-hidden rounded-full bg-slate-100" style={{ width: `${(p.total / max) * 100}%` }}>
        {SEGMENTS.map((s) => p[s.key] ? (
          <div key={s.key} className={`${s.dot} h-full transition-[width] duration-500`} style={{ width: `${(p[s.key] / p.total) * 100}%` }}
            title={`${s.label}: ${fmtMinutes(p[s.key])}`} />
        ) : null)}
      </div>
      <div className="text-right">
        <p className="font-semibold tabular-nums text-slate-900">{fmtMinutes(p.total)}</p>
        {(p.longest || p.shortest) && (
          <span className={`text-[10px] font-bold uppercase tracking-wide ${p.longest ? "text-rose-600" : "text-emerald-600"}`} data-testid={`runtimes-${p.longest ? "longest" : "shortest"}`}>
            {p.longest ? "Longest" : "Shortest"}
          </span>
        )}
      </div>
    </div>
  );
}
